import React from 'react'
import { RefinementList } from 'react-instantsearch/dom'
import { sortBy, prop, reduce, findIndex, propEq } from 'ramda'
import styled from 'styled-components'
import { Theme } from '@pga/pga-component-library'
import FilterItem from './FilterItem'

export const sortByOrder = (config, sortOrder) =>
  reduce((acc, item) => {
    const idx = findIndex(propEq('label', item.label))(sortOrder)
    acc.splice(idx, 0, item)
    return acc
  }, [])(config)

const ShowAllContainer = styled.div`
  i {
    border: solid ${Theme.colors.lightBlue};
    border-width: 0 2px 2px 0;
    display: inline-block;
    padding: 2px;
    margin-left: 5px;
    margin-bottom: ${props => (props.isExpanded ? `0px` : `3px`)}
    ${props => (props.isExpanded ? `transform: rotate(-135deg);` : `transform: rotate(45deg);`)}
  }
`
export const FilterItemWrapper = styled.div`
  display: ${props => props.hidden ? 'none' : 'inherit'};
`

export const ShowMessage = ({ isExpanded }) => (
  <ShowAllContainer isExpanded={isExpanded}>
    {isExpanded ? 'Show Less' : 'Show All'}<i />
  </ShowAllContainer>
)

export default ({ filterName, filterAttribute, showMore = true, showMoreLimit = 20, sortOrder, hidden }) => (
  <FilterItemWrapper hidden={hidden} key={filterName}>
    <FilterItem filterName={filterName}>
      <RefinementList
        showMore={showMore}
        showMoreLimit={showMoreLimit}
        limit={5}
        attribute={filterAttribute}
        translations={{
          showMore: expanded => <ShowMessage isExpanded={expanded} />
        }}
        transformItems={config => sortOrder ? sortByOrder(config, sortOrder) : sortBy(prop('label'))(config)}
      />
    </FilterItem>
  </FilterItemWrapper>
)
